import { Box, Divider, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { _getUserEntities } from '@/api/user-dashboard/queries';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { PagePaths } from '@/routes/page-paths';
import { CustomButton } from '@/shared/components/custom-button';
import CustomModal from '@/shared/components/custom-modal';
import { CustomSelect, TOptions } from '@/shared/components/custom-select';
import { useSelectedUserConfigSlice } from '@/stores/selectors';

export const CreateNewFundModal = () => {
  const navigate = useNavigate();
  const [selectedEntity, setSelectedEntity] = useState<string | null>(null);
  const { open, handleClose } = useGlobalModal('CREATE_NEW_FUND_MODAL');
  const { data, isLoading } = useQuery(_getUserEntities());
  const { setSelectedEntityId, setSelectedUserRole } = useSelectedUserConfigSlice();

  const entityOptions: TOptions[] = (data?.entities ?? []).map((e) => ({
    value: e.entityId,
    label: e.entityName,
  }));

  const handleContinue = () => {
    handleClose();
    setSelectedUserRole('entity');
    setSelectedEntityId(selectedEntity);
    navigate(PagePaths.setupFund);
  };

  return (
    <CustomModal open={open} onClose={handleClose} withCloseButton title="Create New Fund">
      <Stack flexDirection="column" gap="24px">
        <Divider style={{ borderColor: '#464F74', marginTop: '16px' }} />
        <Box>
          <Typography fontWeight="medium" fontSize={18} marginBottom="8px">
            Select Legal Entity
          </Typography>
          <Typography variant="body2" color="#9CA0A2">
            Before creating a new fund, please choose the Legal Entity that this fund will be
            associated with. <br /> You’ll be able to proceed with the full fund setup after
            selecting an entity.
          </Typography>
        </Box>
        <CustomSelect
          withSearch
          displayEmpty
          options={entityOptions}
          fullWidth
          value={selectedEntity ?? ''}
          handleChange={(e) => setSelectedEntity(e?.target?.value as string)}
          disabled={isLoading}
          renderValue={(selected) => (
            <Typography variant="body2">
              {entityOptions?.find((opt) => opt.value === selected)?.label || 'Legal Entity'}
            </Typography>
          )}
          sx={{
            backgroundColor: '#1B202B !important',
            border: '1px solid #383A49 !important',
            height: 42,
          }}
        />

        <CustomButton
          onClick={handleContinue}
          variant="contained"
          disabled={!selectedEntity || isLoading}
          fullWidth
        >
          Continue
        </CustomButton>
      </Stack>
    </CustomModal>
  );
};
